<!-- eslint-disable max-len -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-toolbar flat outlined>
      <v-btn icon :link="false" @click="back">
        <v-icon>fa-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title>Detalles Mascota</v-toolbar-title>
    </v-toolbar>
    <v-container grid-list-md fluid>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <strong>Datos de Identificación</strong>
          <v-divider/>
        </v-flex>
        <v-flex xs12 sm3 md3 style="display: none">
          <v-text-field
            disabled
            v-model="mascota_info.id"
            label="id"
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="mascota_info.nombre"
            label="Nombre"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="mascota_info.especie"
            label="Especie"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="mascota_info.raza"
            label="Raza"
            readonly
         />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="mascota_info.sexo"
            label="Sexo"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="fecha_nacimiento"
            label="Fecha Nacimiento"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="mascota_info.seguro_mascotas"
            label="Seguro Responsabilidad Civil por Daños a Terceros"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="mascota_info.numero_chip"
            label="Número Chip"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="mascota_info.carnet"
            label="Carnet Vacunación o Pasaporte"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-textarea class="my-0 py-0"
            v-model="mascota_info.padecimientos"
            :value="mascota_info.padecimientos"
            label="Padecimientos"
            rows="1"
            no-resize
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-select class="my-0 py-0"
            v-model="mascota_info.caracter"
            label="Carácter"
            :items="tipo_caracter"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-select class="my-0 py-0"
            v-model="mascota_info.profesion"
            label="Tipo o Profesión"
            :items="tipo_profesion"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm12 md12>
          <v-textarea class="my-0 py-0"
            v-model="mascota_info.descripcion_fisica"
            :value="mascota_info.descripcion_fisica"
            label="Descripción Física / Características"
            rows="2"
            no-resize
            readonly
          />
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <strong>En caso de emergencia avisar a</strong>
          <v-divider/>
        </v-flex>
        <v-flex xs12 sm9 md9>
          <v-text-field class="my-0 py-0"
            v-model="mascota_info.emergencia_nombre"
            label="Nombre Completo"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm3 md3>
          <v-text-field class="my-0 py-0"
            v-model="mascota_info.emergencia_telefono"
            label="Celular"
            readonly
          />
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <strong>Datos del Responsable de la Mascota</strong>
          <v-divider/>
        </v-flex>
        <v-flex xs12 sm4 md4>
          <v-text-field class="my-0 py-0"
            v-model="mascota_info.vivienda_responsable"
            label="Vivienda"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm8 md8>
          <v-text-field class="my-0 py-0"
            v-model="residente_responsable_fullname"
            label="Responsable"
            readonly
          />
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <strong>Datos del Propietario de la Mascota</strong>
          <v-divider/>
        </v-flex>
        <v-flex xs12 sm4 md4>
          <v-text-field class="my-0 py-0"
            v-model="mascota_info.vivienda_propietario"
            label="Vivienda"
            readonly
          />
        </v-flex>
        <v-flex xs12 sm8 md8>
          <v-text-field class="my-0 py-0"
            v-model="residente_propietario_fullname"
            label="Propietario"
            readonly
          />
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <strong>Fotos</strong>
          <v-divider/>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <label>Mascota</label>
          <img :src="decode_base64('mascota_foto')" style="width: 100%" alt="Mascota"/>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <label>Mascota</label>
          <img :src="decode_base64('mascota_foto_alt')" style="width: 100%" alt="Mascota"/>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <label>Carnet Veterinario o Pasaporte</label>
          <img :src="decode_base64('mascota_carnet')" style="width: 100%" alt="Carnet Veterinario o Pasaporte"/>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
export default {
  components: {
  },
  data: () => ({
    mascota_info: {},
    residente_responsable_fullname: '',
    residente_propietario_fullname: '',
    fecha_nacimiento: '',
    tipo_caracter: [
      { text: 'Rojo: precaución', value: 'rojo' },
      { text: 'Naranja: no perros', value: 'naranja' },
      { text: 'Amarillo: nervioso/impredecible', value: 'amarillo' },
      { text: 'Verde: amistoso', value: 'verde' },
      { text: 'Azul: en entrenamiento o servicio', value: 'azul' },
      { text: 'Blanco: ciego o sordo', value: 'blanco' },
      { text: 'Morado: no alimentar', value: 'morado' },
    ],
    tipo_profesion: [
      { text: 'Domésticos', value: 'domesticos' },
      { text: 'Compañía', value: 'compania' },
      { text: 'Deportivos', value: 'deportivos' },
      { text: 'Adiestrado', value: 'adiestrados' },
      { text: 'Asistencia', value: 'asistencia' },
      { text: 'Espectáculos', value: 'espectaculos' },
      { text: 'Exhibición', value: 'exhibicion' },
      { text: 'Seguridad y Guarda', value: 'seguridad' },
      { text: 'Animaloterapía', value: 'animaloterapia' },
      { text: 'Silvestres', value: 'silvestres' },
      { text: 'Para venta', value: 'venta' },
    ],
  }),
  computed: {
    is_loading() {
      return this.$store.getters['detallesMascota/is_loading'];
    },
    mascota_processing() {
      return this.$store.getters['detallesMascota/mascota_processing'];
    },
  },
  watch: {
  },
  methods: {
    back() {
      this.$router.back();
    },
    decode_base64(type) {
      let encoded = '';
      let extension = '';
      if (type === 'mascota_foto') {
        encoded = this.mascota_info.mascota_foto_b64;
      } else if (type === 'mascota_foto_alt') {
        encoded = this.mascota_info.mascota_foto_alt_b64;
      } else if (type === 'mascota_carnet') {
        encoded = this.mascota_info.mascota_carnet_b64;
      }
      if (typeof encoded === 'string') {
        const check = encoded.substring(0, 3);
        if (check === '/9j') {
          extension = 'jpg';
        } else if (check === 'iVB') {
          extension = 'png';
        } else if (check === 'SUk') {
          extension = 'tiff';
        } else extension = 'bmp'; // Qk0
      } else {
        extension = 'png';
        encoded = 'R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
      }
      return `data:image/${extension};base64,${encoded}`;
    },
    clear_null(value) {
      let tmpNull = null;
      if (typeof value === 'string') {
        if (value === 'None') {
          tmpNull = '';
        } else {
          tmpNull = value.trim();
        }
      } else if (value === null || typeof value === 'undefined') {
        tmpNull = '';
      } else {
        tmpNull = value;
      }
      return tmpNull;
    },
  },
  created() {
  },
  mounted() {
    this.$store.dispatch('detallesMascota/fetchMascotaInfo', this.$route.params.id)
      .then((data) => {
        this.mascota_info = data.mascota;
        this.residente_responsable_fullname = `${this.clear_null(this.mascota_info.nombre_residente_responsable)} ${this.clear_null(this.mascota_info.apellido_paterno_residente_responsable)} ${this.clear_null(this.mascota_info.apellido_materno_residente_responsable)}`.trim();
        this.residente_propietario_fullname = `${this.clear_null(this.mascota_info.nombre_residente_propietario)} ${this.clear_null(this.mascota_info.apellido_paterno_residente_propietario)} ${this.clear_null(this.mascota_info.apellido_materno_residente_propietario)}`.trim();
        this.fecha_nacimiento = this.clear_null(this.mascota_info.fecha_nacimiento);
        // console.log(this.mascota_info);
      });
  },
};
</script>
<style type="text/css">

</style>
